import React from "react";

export default function FooterFarben() {
    return <>
        <div className="footer-bgk">
            <div className="footer-box bg-purple"></div>
            <div className="footer-box bg-blue"></div>
            <div className="footer-box bg-green"></div>
            <div className="footer-box bg-yellow"></div>
            <div className="footer-box bg-red"></div>
            <div className="footer-box bg-pink"></div>
        </div>
    </>
}